<script setup>
import SportLiveTvButton from '@/sport-live-tv/components/sport-live-tv-button.vue';
import SportLiveTvFilterGroup from '@/sport-live-tv/components/sport-live-tv-filter-group.vue';
import { useSportLiveTvTranslation } from '@/sport-live-tv/composables/use-sport-live-tv-translation';

defineProps({
  group: { type: Object, required: true },
});

const emit = defineEmits(['toggle', 'done']);

const { t } = useSportLiveTvTranslation();
</script>

<template>
  <div class="sport-live-tv-filter-step">
    <SportLiveTvFilterGroup
      :title="group.title"
      :search-placeholder="group.searchPlaceholder"
      :options="group.options"
      :selected="group.selected"
      :search="group.search"
      @update:search="group.onSearchChange"
      @toggle="emit('toggle', group.key, $event)"
    />
    <SportLiveTvButton :label="t('done')" @click="emit('done')" />
  </div>
</template>

<style lang="scss" scoped>
.sport-live-tv-filter-step {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
</style>
